/**
 * Dynamic Form Initializer
 *
 * Call this function during application initialization to register
 * all default field components in the FieldRegistry.
 *
 * This should be called in app.config.ts or main.ts
 */

import { FieldRegistry } from './core/registries/field-registry';
import { ValidatorFactory } from './core/validators/validator-factory';
import { CommonInputComponent } from './common-fields/common-input/common-input.component';
import { DcfCommonTextareaComponent } from './common-fields/common-textarea/common-textarea.component';
import { DcfCommonCheckboxComponent } from './common-fields/common-checkbox/common-checkbox.component';
import { DcfCommonRadioComponent } from './common-fields/common-radio/common-radio.component';
import { DcfCommonToggleComponent } from './common-fields/common-toggle/common-toggle.component';
import { DcfCommonDropdownComponent } from './common-fields/common-dropdown/common-dropdown.component';
import { DcfCommonCalendarComponent } from './common-fields/common-calendar/common-calendar.component';
import { DcfCommonFileUploadComponent } from './common-fields/common-file-upload/common-file-upload.component';
import { DcfCommonRangeComponent } from './common-fields/common-range/common-range.component';
import { DcfCommonColorPickerComponent } from './common-fields/common-color-picker/common-color-picker.component';
import { DcfCommonSubmitButtonComponent } from './common-fields/common-submit-button/common-submit-button.component';

/**
 * Initialize the dynamic form system
 * Registers all default field components
 */
export function initializeDynamicFormSystem(): void {
  // Initialize validators first
  ValidatorFactory.initializeDefaultValidators();

  // Register all field components
  FieldRegistry.register('input', CommonInputComponent);
  FieldRegistry.register('textarea', DcfCommonTextareaComponent);
  FieldRegistry.register('checkbox', DcfCommonCheckboxComponent);
  FieldRegistry.register('radio', DcfCommonRadioComponent);
  FieldRegistry.register('toggle', DcfCommonToggleComponent);
  FieldRegistry.register('dropdown', DcfCommonDropdownComponent);
  FieldRegistry.register('calendar', DcfCommonCalendarComponent);
  FieldRegistry.register('file-upload', DcfCommonFileUploadComponent);
  FieldRegistry.register('range', DcfCommonRangeComponent);
  FieldRegistry.register('color-picker', DcfCommonColorPickerComponent);
  FieldRegistry.register('submit-button', DcfCommonSubmitButtonComponent);

  console.log('[Dynamic Form System] Initialized with', FieldRegistry.getRegisteredTypes().length, 'field types');
}

/**
 * Provider factory for Angular dependency injection
 * Use this in app.config.ts providers array
 */
export function provideDynamicFormSystem() {
  return {
    provide: 'DYNAMIC_FORM_INIT',
    useFactory: () => {
      initializeDynamicFormSystem();
      return true;
    },
    multi: true
  };
}
